var exports = {
  "i": "x93eb46d8--e08d74--wrapper",
  "Z": "x93eb46d8--e08d74--field",
};

module.exports = exports;
